module.exports = __webpack_public_path__ + "img/bonus_symbol_0.943961a5.png";